import { render, staticRenderFns } from "./pointFestivalJoin.vue?vue&type=template&id=5eadf42b&scoped=true"
import script from "./pointFestivalJoin.vue?vue&type=script&lang=js"
export * from "./pointFestivalJoin.vue?vue&type=script&lang=js"
import style0 from "./pointFestivalJoin.vue?vue&type=style&index=0&id=5eadf42b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eadf42b",
  null
  
)

export default component.exports